import React from 'react';
import { LeadPropTypes } from 'components/project/prop_types';
import { useRouteMatch, Link } from 'react-router-dom';
import { useBuildoutOsDisplay } from 'components/buildout_os_display';
import NotFinishedProfileIcon from './show/vault_activity/not_finished_profile_icon';

export default function LeadName({ lead }) {
  const name = <strong>{lead.leadData.name}</strong>;
  const { url } = useRouteMatch();
  const buildoutOs = useBuildoutOsDisplay();
  const leadNameDisplay = buildoutOs ? name :
    <Link
      name={`show-lead-${lead.id}`}
      to={`${url}/${lead.id}`}
    >
      {name}
    </Link>;

  return (
    <div className="d-flex align-items-center">
      <div>{leadNameDisplay}</div>
      <NotFinishedProfileIcon lead={lead} />
    </div>
  );
}

LeadName.propTypes = {
  lead: LeadPropTypes.isRequired
};
